import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { NexpoWorkspace } from '@soft2code/nexpo-lib/core';
import { map } from 'rxjs';

/**
 * Só entra no painel com uma feira escolhida. Toda tela é de **uma** edição:
 * sem isso, um F5 em `/exhibitors` listaria empresas sem saber de qual feira.
 *
 * ⚠️ Ter o id não basta: ele sobrevive ao F5, a lista de feiras não, e é dela
 * que sai o nome no topo. Conferir só o id fazia o nome sumir (medido em
 * 2026-09-02).
 */
export const activeEventGuard: CanActivateFn = () => {
	const workspace = inject(NexpoWorkspace);
	const router = inject(Router);
	if (workspace.hasActive() && workspace.events().length > 0) return true;
	return workspace.load().pipe(map(() => workspace.hasActive() || router.createUrlTree(['/fairs'])));
};
